<template>
  <v-app
    :class="$vuetify.rtl ? `rtl iransans` : `ltr inter`"
    id="inspire"
    :key="applicationHook"
    :style="{
      background:
        $vuetify.theme.themes[$vuetify.theme.dark === true ? 'dark' : 'light']
          .background
    }"
  >
    <transitionPage>
      <router-view />
    </transitionPage>
  </v-app>
</template>

<script>
import transitionPage from "./components/transitionPage/index";
import { mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "App",
  components: { transitionPage },
  computed: {
    applicationHook() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    // this.$vuetify.rtl = true;
    let cookiesLang = this.$cookies.get("lang") || "fa";
    localStorage.setItem("lang", `${cookiesLang}`);
    this.$cookies.set("lang", cookiesLang);

    localStorage.setItem("lang", `${cookiesLang}`);
    this.$cookies.set(
      "lang",
      cookiesLang,
      null,
      null,
      process.env.VUE_APP_COOKIES_DOMAIN
    );

    // if (cookiesLang == null) {
    //   localStorage.setItem("lang", "fa")
    //   this.$cookies.set("")
    //   lang = "fa"
    //   routeLang = "fa"
    // }
    // this.$i18n.locale = lang;
    //
    // if (lang === "fa" || lang === "ar") {
    //   this.$vuetify.rtl = true;
    //   localStorage.setItem("lang", this.$i18n.locale);
    //   localStorage.setItem("direction", "rtl");
    // } else {
    //   this.$vuetify.rtl = false;
    //   localStorage.setItem("lang", this.$i18n.locale);
    //   localStorage.setItem("direction", "ltr");
    // }

    this.$i18n.locale = cookiesLang;
    if (cookiesLang === "fa" || cookiesLang === "ar") {
      this.$vuetify.rtl = true;
      localStorage.setItem("direction", "rtl");
    } else {
      this.$vuetify.rtl = false;
      localStorage.setItem("direction", "ltr");
    }

    if (localStorage.getItem("isDark")) {
      this.$vuetify.theme.dark = localStorage.getItem("isDark") === "true";
    } else {
      this.$vuetify.theme.dark = true;
    }
  },

  methods: {
    ...mapActions({
      isAuthAction: types.auth.actions.ACTION_CHECK_IS_AUTH
    })
  }
};
</script>
